import {base} from "react-netjoy";
import {FilmFilterNetType, FilmNetType} from "../../network_models/films";
import {FilmDuplicatedType, FilmType} from "../../../../models/film";

export function getFilms(filmsFilter: FilmFilterNetType, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/films`
    const req = new base.Request<any, FilmType[], any>()
    req.setEndpointFromState = () => {
        const params = Object.keys(filmsFilter).reduce((acc, key) => {
            const filter: any = (filmsFilter as {[key:string]: any})[key]
            if (Array.isArray(filter)) {
                const arrayStr = filter.reduce((acc, it) => {
                    return `${acc}${acc === '' ? '' : '&'}${key}[]=${it}`
                }, '')
                return `${acc}${acc === '' ? '' : '&'}${arrayStr}`
            } else {
                return `${acc}${acc === '' ? '' : '&'}${key}=${filter}`
            }
        },'')
        console.log('.......>', params)
        return `${url}?${params}`
        return url
    }
    req.method = 'GET'
    req.transformResponseDataWithState = (res) => {
        return res.original?.data?.data || []
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function postFilmsAutocomplete(films: FilmType[], onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/films/?type=autocomplete`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'POST'
    req.setBodyFromState = () => {
        return films
    }
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function updateFilms(id: number, film: FilmType, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/films/${id}`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'PATCH'
    req.setBodyFromState = () => film
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function deleteFilm(id: number, onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/films/${id}/`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'DELETE'
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function getDuplicates(onSuccess?: (res: FilmDuplicatedType[]) => void, onFailure?: (error: any) => void) {
    const url = `/films/duplicated/`
    const req = new base.Request<{}, FilmDuplicatedType[], any>()
    req.setEndpointFromState = () => url
    req.method = 'GET'
    req.transformResponseDataWithState = (res) => {
        console.log(res)
        return res.original?.data?.data
    }
    req.transformErrorDataWithState = (error) => {
        console.log(error)
        return error.original
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    return req
}

export function getNextFolderAvailable(onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/films/empty_folders?cb=${Date.now()}`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'GET'
    req.transformResponseDataWithState = (res) => {
        console.log(res)
        return (res.original?.data?.data.length > 0) ? res.original?.data?.data[0].folder_name : undefined
    }
    req.transformErrorDataWithState = (error) => {
        console.log('getNextFolderAvailable transformErrorDataWithState')
        console.log(error)
        return error
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    req.onFinish = () => {
        console.log('-----------------------------> Finish')
    }
    return req
}

export function delayReq(onSuccess?: (res: any) => void, onFailure?: (error: any) => void) {
    const url = `/films/delay/`
    const req = new base.Request()
    req.setEndpointFromState = () => url
    req.method = 'GET'
    req.transformResponseDataWithState = (res) => {
        console.log(res)
    }
    req.transformErrorDataWithState = (error) => {
        console.log('transformErrorDataWithState')
        console.log(error)
        return error
    }
    if (onSuccess) req.onSuccess = onSuccess
    if (onFailure) req.onFailure = onFailure
    req.onFinish = () => {
        console.log('-----------------------------> Finish')
    }
    return req
}
